import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLogin: false,
  name: null,
  nricFin: null,
  tokenisedId: null,
};

export const singPassIdentifySlice = createSlice({
  name: "singPassIdentify",
  initialState,
  reducers: {
    setIsLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setNricFin: (state, action) => {
      state.nricFin = action.payload;
    },
    setTokenisedId: (state, action) => {
      state.tokenisedId = action.payload
    }
  }
});

export const { setIsLogin, setName, setNricFin, setTokenisedId } = singPassIdentifySlice.actions;

export default singPassIdentifySlice.reducer;
